import { useEffect, useState } from 'react';
import posthog from 'posthog-js';

function evaluate(key: string): boolean {
  // E2E escape hatch — set window.__E2E_FEATURE_FLAGS__[key] before app mount.
  // Lets Playwright tests force a flag on/off without standing up PostHog.
  if (typeof window !== 'undefined') {
    const override = (window as any).__E2E_FEATURE_FLAGS__?.[key];
    if (typeof override === 'boolean') return override;
  }
  return !!posthog.isFeatureEnabled?.(key);
}

export function useFeatureFlag(key: string): boolean {
  const [enabled, setEnabled] = useState<boolean>(() => evaluate(key));

  useEffect(() => {
    const unsubscribe = posthog.onFeatureFlags(() => {
      setEnabled(evaluate(key));
    });
    return () => {
      unsubscribe?.();
    };
  }, [key]);

  return enabled;
}
